import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import { questionPropType } from '../questionTypes';
import QuestionFormBody from './QuestionFormBody';

// some questions, like date, might want validation to run on different events
// these custom props go into <Formik />
const customFormikValidations = {
  date: {
    // disable validation on input change
    validateOnChange: false,
  },
};

export function QuestionForm({
  clearErrorMessage, errorMessage, isMobile, onContinue, onSkip, question, showProfileWarning, totalQuestions,
  setIsLoading,
}) {
  const fieldName = question.question_type === 'upload' ? 'answerUpload' : 'answer';
  const fieldValue = question.question_type === 'multiple-answer' ? [] : '';
  const customFormikValidation = customFormikValidations[question.question_type] || {};

  return (
    <Formik
      initialValues={{ [fieldName]: fieldValue }}
      enableReinitialize
      onSubmit={(values, { resetForm, setSubmitting }) => onContinue(values, resetForm, setSubmitting)}
      {...customFormikValidation}
    >
      <QuestionFormBody
        clearErrorMessage={clearErrorMessage}
        errorMessage={errorMessage}
        fieldName={fieldName}
        isMobile={isMobile}
        question={question}
        onSkip={onSkip}
        showProfileWarning={showProfileWarning}
        totalQuestions={totalQuestions}
        setIsLoading={setIsLoading}
      />
    </Formik>
  );
}

QuestionForm.propTypes = {
  clearErrorMessage: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  isMobile: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
  onSkip: PropTypes.func.isRequired,
  question: questionPropType.isRequired,
  setIsLoading: PropTypes.func,
  showProfileWarning: PropTypes.bool,
  totalQuestions: PropTypes.number.isRequired,
};

QuestionForm.defaultProps = {
  errorMessage: '',
  isMobile: false,
  setIsLoading: () => {},
  showProfileWarning: false,
};

export default QuestionForm;
